export const RECEIVE_TRAINING_MODULE = 'RECEIVE_TRAINING_MODULE';
export const MENU_TOGGLE = 'MENU_TOGGLE';
export const REVIEW_ANSWER = 'REVIEW_ANSWER';
export const SET_CURRENT_SLIDE = 'SET_CURRENT_SLIDE';
export const RECEIVE_ALL_TRAINING_MODULES = 'RECEIVE_ALL_TRAINING_MODULES';
export const SLIDE_COMPLETED = 'SLIDE_COMPLETED';
export const EXERCISE_COMPLETION_UPDATE = 'EXERCISE_COMPLETION_UPDATE';
